module.exports = function getResource(label) {
    let resources = {
        selectAShade: 'Select a Shade',
        next: 'Next'
    };
    return resources[label];
};
